import React from 'react'
import { MoreVert } from '@mui/icons-material'

export const tripActivitiesMenuConfig = ({ row, deleteActivity, editActivity }) => {
  return {
    button: {
      icon: <MoreVert style={{ color: 'gray' }} />,
    },
    content: {
      menu: {
        items: [
          {
            id: 1,
            title: 'Delete',
            onClick: () => {
              deleteActivity(row)
            },
          },
          {
            id: 2,
            title: 'Edit',
            onClick: () => {
              editActivity(row)
            },
          },
        ],
      },
    },
  }
}
